import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
@Injectable({
  providedIn: 'root'
})
export class OrganizationService {

  constructor() { }
  static formFields() {
    return {
      'y_identifier': [null,Validators.required],
      'company_name': [null,Validators.required],
      'website_link': [null,Validators.required],
      'description': [null,Validators.required]
   
    }
  }
}
